import React, { useState, useEffect } from 'react';
import { MessageCircle, ChevronUp } from 'lucide-react';
import { contactInfo } from '../data/mockData';
import '../styles/floating-buttons.css';

const FloatingButtons = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openWhatsApp = () => {
    const message = encodeURIComponent('Hi! I would like to inquire about cricket coaching programs at ClutchCricket.');
    window.open(`https://wa.me/${contactInfo.whatsapp.replace(/\D/g, '')}?text=${message}`, '_blank');
  };

  return (
    <div className="floating-buttons">
      {/* WhatsApp Button */}
      <button
        className="floating-btn whatsapp-btn"
        onClick={openWhatsApp}
        aria-label="Contact on WhatsApp"
      >
        <MessageCircle size={24} />
        <span className="btn-tooltip">WhatsApp</span>
      </button>

      {/* Scroll to Top */}
      {showScrollTop && (
        <button
          className="floating-btn scroll-top-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <ChevronUp size={24} />
        </button>
      )}
    </div>
  );
};

export default FloatingButtons;
